<template>
  <div>
    <section>
      <v-container>
        <div class="category-list">
          <CategoryNavigation
            title="Semua Event"
            class="mr-2"
            :to="{ name: 'Explore' }"
          />
          <CategoryNavigation
            v-for="tag in categories"
            :key="tag.id"
            class="mr-2"
            :title="tag.name"
            :to="{ name: 'CategoryEvent', params: { slug: tag.slug } }"
          />
        </div>
      </v-container>
    </section>
    <section>
      <v-container>
        <v-row justify="space-between">
          <v-col>
            <v-skeleton-loader
              :loading="loading"
              type="list-item"
              max-width="200"
            >
              <h4>Kategori {{ categorySlugSelected }}</h4>
            </v-skeleton-loader>
          </v-col>
        </v-row>
        <div>
          <v-row v-if="loading">
            <v-col cols="12" sm="6" md="3" v-for="(item, i) in 8" :key="i">
              <v-skeleton-loader type="card"></v-skeleton-loader>
            </v-col>
          </v-row>
          <v-row v-else-if="loadData.length <= 0">
            <v-col>
              <EmpytState />
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col cols="12" md="3" v-for="(item, i) in loadData" :key="i">
              <PosterCard
                :title="item.title"
                :date="item.event_date"
                :is_post_event="item.post_event"
                :publisher="item.publisher"
                :publisher_badge="item.publisher_badge"
                :poster="item.cover"
                :route="{
                  name: 'EventDetail',
                  params: { slug: item.slug, id: item.id },
                }"
              />
            </v-col>
          </v-row>
        </div>
      </v-container>
    </section>

    <v-snackbar v-model="error">
      {{ errorMessage }}
      <v-btn dark color="pink" text @click="error = false"> Close </v-btn>
    </v-snackbar>
    <v-snackbar v-model="errorPastEvents">
      {{ errorMessagePastEvents }}
      <v-btn dark color="pink" text @click="errorPastEvents = false">
        Close
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import PosterCard from '../components/PosterCard';
import Axios from 'axios';
import CategoryNavigation from '@/components/CategoryNavigation';
import EmpytState from '@/components/EmpytState';

export default {
  metaInfo() {
    return {
      title: 'Semua event kampus akan datang',
      titleTemplate: '%s - Eventversity',
      htmlAttrs: {
        lang: 'id',
        amp: true,
      },
    };
  },
  name: 'ExploreCategory',
  components: {
    EmpytState,
    CategoryNavigation,
    PosterCard,
  },
  data() {
    return {
      loading: true,
      loadingPastEvent: true,
      loadData: [],
      loadDataPastEvents: [],
      error: false,
      errorPastEvents: false,
      errorMessage: null,
      errorMessagePastEvents: null,
      categories: [],
      categorySlugSelected: this.$route.params.slug,
      isActive: true,
    };
  },
  mounted() {
    this.loadEventByCategory(this.categorySlugSelected);
    this.loadCategoryList();
  },
  methods: {
    loadEventByCategory(slug) {
      Axios.get(process.env.VUE_APP_API + 'events?category_slug=' + slug)
        .then((response) => {
          this.loadData = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          this.error = true;
          this.errorMessage = error;
        })
        .finally(() => (this.loading = false));
    },

    loadCategoryList() {
      // categories
      Axios.get(process.env.VUE_APP_API + 'category')
        .then((response) => {
          this.categories = response.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  watch: {
    $route(to) {
      this.categorySlugSelected = to.params.slug;
      this.loadCategoryList();
      this.loadEventByCategory(this.categorySlugSelected);
      this.isActive = false;
    },
  },
};
</script>

<style scoped>
.category-list {
  margin-top: 0.5rem;
  overflow: hidden;
  white-space: nowrap;
  overflow-x: scroll;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 16px;
}
</style>
